module.exports = __webpack_public_path__ + "img/temperature-md.3cf79351.svg";